import { lazy } from 'react'

export const DeleteInstanceModalAsync = lazy(() =>
    import('./DeleteInstanceModal').then((module) => ({
        default: module.DeleteInstanceModal,
    }))
)
